var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex w-full flex-col md:flex-row"},[_c('div',{staticClass:"flex-grow"},[_c('DynamicTabs',{attrs:{"tabs":_vm.tabs}})],1),(_vm.hasSidebarSlot)?_c('div',{staticClass:"mb-4 flex justify-end md:mb-0 md:ml-2"},[_vm._t("sidebar")],2):_vm._e()]),_c('Alert',{staticClass:"mb-4",attrs:{"error":_vm.error}}),_c('div',{class:_vm.grid
                ? 'grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4'
                : 'flex flex-col'},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }